import i18n from '@/plugins/i18n';

const applicationGraphs = {
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('timeToFirstByte'),
      header: {
        title: i18n.global.t('timeToFirstByte'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#008ffb'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_page_ttfb_avg',
      queryMetricType: 'getGraphData',

      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('milliseconds'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('milliseconds'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dom-analysis-time'),
      header: {
        title: i18n.global.t('dom-analysis-time'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff8022'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_page_dom_analysis_avg',
      queryMetricType: 'getGraphData',

      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('milliseconds'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('milliseconds'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('firstPaintTime'),
      header: {
        title: i18n.global.t('firstPaintTime'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#98ed78'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_page_fpt_avg',
      queryMetricType: 'getGraphData',

      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('milliseconds'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('milliseconds'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('pageLoadTime'),
      header: {
        title: i18n.global.t('pageLoadTime'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#c8584d'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_page_load_page_avg',
      queryMetricType: 'getGraphData',

      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('milliseconds'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('milliseconds'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('transTime'),
      header: {
        title: i18n.global.t('transTime'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#88bcba'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_page_trans_avg',
      queryMetricType: 'getGraphData',

      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('milliseconds'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('milliseconds'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('errorCount'),
      header: {
        title: i18n.global.t('errorCount'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#c457c2'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_error_sum',
      queryMetricType: 'getGraphData',

      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfErrors'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('numberOfErrors'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('firstMeaningPaint'),
      header: {
        title: i18n.global.t('firstMeaningPaint'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#dd7bae'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_page_fmp_avg',
      queryMetricType: 'getGraphData',

      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('milliseconds'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('milliseconds'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('tcpTime'),
      header: {
        title: i18n.global.t('tcpTime'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#edf362'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_page_tcp_avg',
      queryMetricType: 'getGraphData',

      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('milliseconds'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('milliseconds'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('redirectTime'),
      header: {
        title: i18n.global.t('redirectTime'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#b797ee'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_page_redirect_avg',
      queryMetricType: 'getGraphData',

      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('milliseconds'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('milliseconds'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('ttlTime'),
      header: {
        title: i18n.global.t('ttlTime'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#008ffb'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_page_ttl_avg',
      queryMetricType: 'getGraphData',

      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('milliseconds'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('milliseconds'),
      },
    },
  ],
};
export default applicationGraphs;
